import React, { useEffect, useState } from "react";
import BackButton from "../../../components/common/BackButton";
import RestaurantForm from "../../../components/forms/RestaurantForm";
import { useSelector } from "react-redux";
import { useFirestoreConnect, isLoaded } from "react-redux-firebase";
import LoadingIndicator from "../../../components/common/LoadingIndicator";

const GeneralPage = ({}) => {
  const [restaurantId, setRestaurantId] = useState("");

  const uid = useSelector(({ firebase }) => firebase.auth.uid);

  useFirestoreConnect([
    { collection: "restaurants", where: [["user_id", "==", uid]] },
  ]);

  const restaurant = useSelector(({ firestore }) =>
    firestore.ordered.restaurants ? firestore.ordered.restaurants[0] : {}
  );

  useEffect(() => {
    if (isLoaded(restaurant)) setRestaurantId(restaurant.id);
  }, [restaurant]);

  if (!isLoaded(restaurant)) return <LoadingIndicator></LoadingIndicator>;

  return (
    <div className={`px-16 py-8 text-gray-900 min-h-screen`}>
      <BackButton></BackButton>
      <div className="bg-white mt-4 shadow-sm border rounded-sm">
        <p className="px-6 py-3 border-b">Administrar datos generales</p>
        <div className="bg-gray-100 px-6 py-3 relative text-gray-700 text-md">
          <RestaurantForm
            startTime={restaurant.startTime}
            endTime={restaurant.endTime}
            pricePerKilometer={restaurant.pricePerKilometer}
            radius={restaurant.radius}
            minOrderTotal={restaurant.minOrderTotal}
            estimatedTime={restaurant.estimatedTime}
            latitude={restaurant.latitude}
            longitude={restaurant.longitude}
            available={restaurant.available}
            id={restaurant.id}
          ></RestaurantForm>
        </div>
      </div>
    </div>
  );
};

export default GeneralPage;
